<template>
  <div class="coupon-three-order-item" :class="[!current  ? 'opacity' : '', couponType ]">
    <div class="coupon-title">
      第{{ index + 1 }}单可享
    </div>
    <div class="coupon-discount">
      <div v-if="isFullAmount">
        <span class="number">{{ coupon.cash_reduce/100 }}</span>元
      </div>
      <div v-if="isFullOrder">
        <span class="number">{{ formatDiscount }}</span>折
      </div>
      <div v-if="isFreeOrder">
        免<span class="number">{{ coupon.reduce_num }}</span>单
      </div>
    </div>
    <div class="coupon-threshold">
      <div>{{ getCondition }}</div>
    </div>
  </div>
</template>


<script>
import utils from '@/libs/utils';

export default {
  components: {
  },
  props: {
    current: Boolean,
    coupon: Object,
    index: Number,
  },
  data() {
    return {};
  },
  computed: {
    isFullAmount() {
      return this.coupon && this.coupon.coupon_type_id === 0;
    },
    isFullOrder() {
      return this.coupon && this.coupon.coupon_type_id === 1;
    },
    isFreeOrder() {
      return this.coupon && this.coupon.coupon_type_id === 2;
    },
    formatDiscount() {
      return utils.formatNumberWithDecimals(this.coupon.cash_reduce / 1000);
    },
    getCondition() {
      if (this.isFreeOrder) {
        return `满${this.coupon.reach_reduce_num}本可用`;
      } else if (this.coupon.reach_reduce) {
        return `满${this.coupon.reach_reduce / 100}元可用`;
      }
      return '无门槛';
    },
    couponType() {
      if (!this.coupon) return;
      if (this.coupon.status === 1) { // 已使用
        return 'used';
      } else if (this.coupon.status === 0 && this.coupon.remaining_seconds <= 0) { // 未使用并且过期
        return 'expired';
      }
    },
  },

};

</script>


<style lang="less" scoped>
.coupon-three-order-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: url(../../../assets/imgs/activity/three-order-activity/index-three-order-coupon.png) no-repeat center;
  background-size: 100% 100%;
  width: 188px;
  height: 178px;
  &.used {
    background: url(../../../assets/imgs/activity/three-order-activity/index-three-order-coupon-used.png) no-repeat center center;
    background-size: 100% 100%;
    opacity: 1;
  }
  &.expired {
    background: url(../../../assets/imgs/activity/three-order-activity/index-three-order-coupon-expired.png) no-repeat center center;
    background-size: 100% 100%;
    opacity: 1;
  }
  &:first-child {
    margin-left: 0;
  }
  .coupon-title {
    color: #2F333D;
    line-height: 25px;
    font-weight: 600;
  }
  .coupon-discount {
    margin-top: 8px;
    color: #F43344;
    display: flex;
    align-items: flex-end;
    .number {
      font-size: 48px;
      line-height: 48px;
    }
  }
  .coupon-threshold {
    margin-top: 32px;
    color: #2F333D;
    line-height: 20px;
  }
  &.opacity {
    .coupon-title {
      opacity: 0.45;
    }
    .coupon-discount{
      opacity: 0.45;
    }
    .coupon-threshold {
      opacity: 0.45;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity/coupon-item/coupon-three-order-item.vue